<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-26 15:02:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-22 09:57:23
 * @FilePath: /goldenSalesMobile/src/components/MyTabBar/index.vue
 * @Description: tabBar组件
-->
<template>
  <div class="tabBar-box">
    <van-tabbar
      v-model="activeTabIndex"
      active-color="var(--tc)"
      inactive-color="#666666"
      :border="false"
    >
      <van-tabbar-item
        v-for="(item, index) in tabBarList"
        replace
        :key="index"
        :to="item.routePath"
      >
        <span>{{ item.name }}</span>
        <template #icon="props">
          <img :src="props.active ? item.icon.active : item.icon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTabIndex: 0,
      tabBarList: [],
      salersTabBarData: [
        {
          name: "分销商品",
          icon: {
            active: require("@/assets/tab_image/tab_home2.png"),
            inactive: require("@/assets/tab_image/tab_home1.png"),
          },
          routePath: "goods-list",
        },
        {
          name: "分销订单",
          icon: {
            active: require("@/assets/tab_image/tab_order2.png"),
            inactive: require("@/assets/tab_image/tab_order1.png"),
          },
          routePath: "sales-order",
        },
        {
          name: "个人中心",
          icon: {
            active: require("@/assets/tab_image/tab_wode2.png"),
            inactive: require("@/assets/tab_image/tab_wode1.png"),
          },
          routePath: "account-center",
        },
      ],
      usersTabBarData: [
        {
          name: "商城",
          icon: {
            active: require("@/assets/tab_image/tab_home2.png"),
            inactive: require("@/assets/tab_image/tab_home1.png"),
          },
          routePath: "shopping-list",
        },
        {
          name: "订单",
          icon: {
            active: require("@/assets/tab_image/tab_order2.png"),
            inactive: require("@/assets/tab_image/tab_order1.png"),
          },
          routePath: "/users/users-order",
        },
        {
          name: "我的",
          icon: {
            active: require("@/assets/tab_image/tab_wode2.png"),
            inactive: require("@/assets/tab_image/tab_wode1.png"),
          },
          routePath: "account-center",
        },
      ],
    };
  },

  created() {
    // if (this.$route.fullPath.includes('/users/')) { // 渲染消费者界面的tabBar
    this.tabBarList = this.usersTabBarData;
    // } else { // 渲染分销员界面的tabBar
    //   this.tabBarList = this.salersTabBarData
    // }
    switch (this.$route.name) {
      case "GoodsList":
        this.activeTabIndex = 0;
        break;
      case "SalesOrder":
        this.activeTabIndex = 1;
        break;
      case "AccountCenter":
        this.activeTabIndex = 2;
        break;
      case "ShoppingList":
        this.activeTabIndex = 0;
        break;
      case "UsersOrder":
        this.activeTabIndex = 1;
        break;
      case "UsersAccountCenter":
        this.activeTabIndex = 2;
        break;
      default:
        this.activeTabIndex = 0;
        break;
    }
  },
};
</script>

<style lang="scss" scoped>
.tabBar-box {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 0px 14px 0px rgba(182, 182, 182, 0.5);
}
</style>
